import { z } from "zod"
import { SalesForceIntegrationModels } from "./dtos"

export const SalesForceObjectTypeEnum = z.enum([
  "id",
  "boolean",
  "reference",
  "string",
  "picklist",
  "textarea",
  "double",
  "address",
  "phone",
  "email",
  "datetime",
  "date",
  "url",
  "multipicklist",
])

export const ContactObject = z.object({
  fields: z.array(
    z.object({
      label: z.string(),
      name: z.string(),
      type: SalesForceObjectTypeEnum,
      picklistValues: z
        .array(
          z.object({
            active: z.boolean(),
            defaultValue: z.boolean(),
            label: z.string(),
            value: z.string(),
          }),
        )
        .optional(),
    }),
  ),
})

export const SalesForceIntegrationResponseDataSchema = z
  .object({
    baseUrl: z.string(),
    clientId: z.string(),
    clientSecret: z.string(),
    redirectUrl: z.string(),
    refreshToken: z.string(),
  })
  .nullable()

export const SalesForceModelMapResponseDataSchema = z.object({
  fields: z.array(
    z.object({
      label: z.string(),
      name: z.string(),
      type: SalesForceObjectTypeEnum,
      picklistValues: z
        .array(
          z.object({
            active: z.boolean(),
            defaultValue: z.boolean(),
            label: z.string(),
            value: z.string(),
          }),
        )
        .optional(),
    }),
  ),
})

export const SalesForceModelsRespnseDataSchema = z.array(
  z.object({
    name: SalesForceIntegrationModels,
    fields: z.array(z.string()),
    values: z.record(z.string(), z.string()),
  }),
)

export const SalesForceCreateModelKeyMapRespnseDataSchema = z.array(
  z.object({
    model: SalesForceIntegrationModels,
    key: z.string(),
    source: z.string(),
  }),
)
